import React, { useState } from 'react';
// import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { VIEW_CRQ } from 'AppSrc/core/components/router/routes';
// import {
//   getStageNameForStatus,
// } from 'AppSrc/core/crq/crq-table-utils';
import { RefreshIcon } from 'AppSrc/core/components/common/svg-icons';
import { formDataShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import { getCrq } from 'AppSrc/core/crq/crq-queries';
import { getIsInternationalCrq } from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { OptionButton } from '../utility/option-button';
// import { AddApproversModal } from './modals/add-approvers-modal';
import 'AppSrc/core/style/components/form/form-base-components/v-f-button-selector.css';
import 'AppSrc/core/style/components/utility/loading-spinner.css';
// import data from './data.json';
import { getStatusParameterFixed } from '../../crq/crq-statuses';
import { RelatedCoordinatorTableVine } from './view-crq-related-coordinator-table';
// import { fetchCrqForRemedyRef } from '../../actions/actions-edit-form';

const ViewCrqCreateRelatedNetwork = React.memo(({
  // crqId,
  formData,
  realNetwork,
  isCreateMobileCrq,
  hasReferenceCRQ,
  isChangeAnalyst,
}) => {
  const [selectedOption, setSelectedOption] = useState('No');
  const [fetchingStatus, setFetchingStatus] = useState(false);
  const [relatedStatus, setRelatedStatus] = useState('');
  // const dispatch = useDispatch();

  // const history = useHistory();

  // const handlLink = () => {
  //   const { adjacentRemedyRef } = formData;
  //   history.push(`crq'/${network === 'fixed' ? 'Mobile ' : 'Fixed '}/${adjacentRemedyRef}`);
  // };

  const network = realNetwork === 'fixed' ? 'mobile' : 'fixed';
  const crqId = formData.adjacentRemedyRef;
  const viewCrqPath = VIEW_CRQ.getPath({ network, crqId });
  const isInternationalCrq = getIsInternationalCrq(formData);

  const handleGetCurrentStatus = () => {
    const { adjacentRemedyRef } = formData;
    const refCrqId = adjacentRemedyRef;
    if (refCrqId) {
      // const inverseNetwork = network === 'fixed' ? 'mobile' : 'fixed';
      // dispatch(fetchCrqForRemedyRef(refCrqId, inverseNetwork)).catch((error) => {
      //   console.error(error);
      //   // error ref crq
      // });
      setFetchingStatus(true);
      getCrq(network, refCrqId).then(({ crq }) => {
        const { status } = crq;
        const currentStatus = network === 'mobile' ? status : getStatusParameterFixed(status, network);
        setRelatedStatus(currentStatus);
        setFetchingStatus(false);
      }).catch((error) => {
        console.error(error);
      });
    }
  };

  const handleTabClick = (tab) => {
    setSelectedOption(tab);
    isCreateMobileCrq(tab);
  };

  const createVine = [
    {
      id: 'Yes',
      label: 'Yes',
    },
    {
      id: 'No',
      label: 'No',
    },
  ];

  return (
    <>
      <div className="view-crq-create-related-network">
        <div className="main-related-mobile-title">
          <h3>
            {
              realNetwork === 'fixed' ? 'Mobile ' : 'Fixed '
            }
            Reference
          </h3>
        </div>
        {
          (formData.status === '4' && formData.statusReason === '10500' && isChangeAnalyst && !isInternationalCrq) && (
            <>
              <div className="outer-yes-no">
                <div className="v-f-field-type v-f-button-selector v-f-button-selector-standard v-f-button-selector-example yes-no-btn">
                  <div className="create-ticket-header-wrap">
                    <h3>Do you want to create mobile ticket for this change?</h3>
                    <p><i>Please verify the Service Impact Assessment report for mobile changes before creating a mobile-related ticket.</i></p>
                  </div>
                  <div className="button-options button-option-wrapper">
                    {createVine.map(({ id, label }) => (
                      <div
                        className="button-option-wrapper"
                        key={id}
                      >
                        <OptionButton
                          className={`button-option ${selectedOption && selectedOption.includes(id) ? 'button-option-selected' : ''}`}
                          option={id}
                          onClick={handleTabClick}
                          key={id}
                        >
                          <span className="tab-statistic-label">{label}</span>
                        </OptionButton>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {
                selectedOption === 'Yes' && (
                  <RelatedCoordinatorTableVine
                    isCreateRelated={selectedOption}
                  />
                )
              }
            </>
          )
        }
        { hasReferenceCRQ() === true && (
        <div className="outer-view-related-status">
          <div className="view-related-change-id-and-status">
            <div className="crq-id-reference-wrapper row-100">
              <p>Change Reference</p>
              <h3>
                <Link to={viewCrqPath} target="_blank">
                  {formData.adjacentRemedyRef}
                </Link>
              </h3>
            </div>
            <div className="status-row-wrapper row-100">
              <p>
                Status
              </p>
              <div className="status-checker-live">
                <p className={`sand-clock-svg ${fetchingStatus ? 'loading-status' : ''}`}>
                  <svg viewBox="0 0 32 32">
                    <path className="st1" d="M22,6H10C8.3,6,7,4.7,7,3v0h18v0C25,4.7,23.7,6,22,6z" />
                    <path className="st1" d="M10,26h12c1.7,0,3,1.3,3,3v0H7v0C7,27.3,8.3,26,10,26z" />
                    <path className="st1" d="M23,26v-4c0-0.6-0.3-1.2-0.8-1.6l-3.7-2.8c-1.1-0.8-1.1-2.4,0-3.2l3.7-2.8c0.5-0.4,0.8-1,0.8-1.6V6" />
                    <path className="st1" d="M9,6v4c0,0.6,0.3,1.2,0.8,1.6l3.7,2.8c1.1,0.8,1.1,2.4,0,3.2l-3.7,2.8C9.3,20.8,9,21.4,9,22v4" />
                    <polygon className="st1" points="11,26 16,21 21,26 " />
                    <polygon className="st1" points="16,12 13,10 19,10 " />
                  </svg>
                </p>
                <p className="current-status-related">
                  <i>
                    {relatedStatus}
                    {fetchingStatus ? 'Loading...' : ''}
                  </i>
                </p>
                <p className="related-refresh-btn outer-back-refr-wrap loading-spinner">
                  <button type="button" title="Get current status" onClick={handleGetCurrentStatus}>
                    <RefreshIcon />
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
        )}
      </div>
    </>
  );
});

ViewCrqCreateRelatedNetwork.propTypes = {
  // crqId: PropTypes.string,
  formData: formDataShape,
  realNetwork: PropTypes.string,
  isCreateMobileCrq: PropTypes.func,
  hasReferenceCRQ: PropTypes.bool,
  isChangeAnalyst: PropTypes.bool,
};

export { ViewCrqCreateRelatedNetwork };
